export const logoOverlayRightDark = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Logo Overlay</title>

    <style>
      * {
        box-sizing: border-box;
      }

      html,
      body,
      .logoOverlayRightDark #fullheight {
        min-height: 100% !important;
        height: 100%;
        padding: 0;
        margin: 0;
        /* Change font for Clients in the future */
        font-family: "Roboto", sans-serif;
      }

      .logoOverlayRightDark {
        max-width: 1920px;
        min-width: 1920px;
        max-height: 1080px;
        width: 100%;
        height: 100%;

        padding: 60px;
        // background: url("https://images.pexels.com/photos/1181605/pexels-photo-1181605.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
        background-size: cover;
        background-repeat: no-repeat;
      }
      .logoOverlayRightDark .frameOverlay {
        background: rgb(255, 255, 255);
        background: linear-gradient(
          16deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0) 65%,
          rgba(255, 255, 255, 0.7) 100%
        );
        
        position: absolute;
        top: 0;
        right: 0;
        height: 60%;
        width: 60%;
      }
      .logoOverlayRightDark .frameContent {
        width: 100%;
        height: 100%;
        text-align: right;
        /* display: flex;
        justify-content: flex-end; */
        position: relative;
      }
      .logoOverlayRightDark img.frameLogo {
        max-width: 400px;
        height: auto;
        width: 100%;
      }
      .logoOverlayRightDark h1.frameLogoText {
        margin: 0;
        padding: 0;
        font-size: 62px;
        line-height: 60px;
        font-weight: 700;
        letter-spacing: 1px;
        text-align: right;
        color: #fff;
      }
    </style>
  </head>
  <body >
    <div class="logoOverlayRightDark">

      <div class="frameOverlay"></div>
      <div class="frameContent">
        <!-- <h1 class="frameLogoText">LOGO</h1> -->
        <img
          class="frameLogo"
          src="{LOGO_DARK}"
        />
      </div>

    </div>
  </body>
</html>
`;

export const logoOverlayRightLight = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Logo Overlay</title>

    <style>
      * {
        box-sizing: border-box;
      }

      html,
      body,
      .logoOverlayRightLight #fullheight {
        min-height: 100% !important;
        height: 100%;
        padding: 0;
        margin: 0;
        /* Change font for Clients in the future */
        font-family: "Roboto", sans-serif;
      }

      .logoOverlayRightLight {
        max-width: 1920px;
        min-width: 1920px;
        max-height: 1080px;
        width: 100%;
        height: 100%;
        padding: 60px;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .logoOverlayRightLight .frameOverlay {
        background: rgb(0, 0, 0);
        background: linear-gradient(
          16deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) 70%,
          rgba(0, 0, 0, 0.5718662464985995) 100%
        );
        position: absolute;
        top: 0;
        right: 0;
        height: 60%;
        width: 60%;
      }
      .logoOverlayRightLight .frameContent {
        width: 100%;
        height: 100%;
        text-align: right;
        /* display: flex;
        justify-content: flex-end; */
        position: relative;
      }
      .logoOverlayRightLight img.frameLogo {
        max-width: 400px;
        height: auto;
        width: 100%;
      }
      .logoOverlayRightLight h1.frameLogoText {
        margin: 0;
        padding: 0;
        font-size: 62px;
        line-height: 60px;
        font-weight: 700;
        letter-spacing: 1px;
        text-align: right;
        color: #fff;
      }
    </style>
  </head>
  <body>
    <div class="logoOverlayRightLight">

        <div class="frameOverlay"></div>
        <div class="frameContent">
          <!-- <h1 class="frameLogoText">LOGO</h1> -->
          <img
            class="frameLogo"
            src="{LOGO_LIGHT}"
          />
        </div>
    </div>
  </body>
</html>
`;
